import { Directive, Host, Input } from '@angular/core';
import { FormElementComponent } from '@kalidea/kaligraphi';

/**
 * permet de spécifier la valeur d'un champs select ou input directement
 */

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'kal-select[value], kal-input[value]'
    // selector: 'app-number-range[value], app-date-range[value], kal-select[value], kal-input[value]'
    ,
    standalone: false
})
export class FormElementValueDirective<T> {

    constructor(@Host() private readonly formElement: FormElementComponent) {
    }

    @Input()
    set value(value: T) {
        if (this.formElement) {
            try {
                this.formElement.writeValue(value);
            } catch (e) {
            }
        }
    }

}
